export default "__VITE_ASSET__CeYu06li__"